'use client'
import React, { useId, useState, useRef } from 'react';
import { Icon } from '@/stories/atoms/Icon/Icon';
import { useClickOutside } from '@/hooks/useClickOutside';

import { MenuLink } from './MenuLink';
import styles from './sub-menu.module.css';
import link from './menu-link.module.css';

export type MenuLink = {
  label: string;
  url: string;
}


export type SubMenuProps = {
  parentOpen: boolean,
  item: {
    label: string;
    child: MenuLink[];
  }
}

export const SubMenu = ({item: {label, child}, parentOpen}: SubMenuProps) => {
  const [open, setOpen] = useState(false)
  const id = useId()
  const ref =  useRef(null)
  useClickOutside(ref, () => setOpen(false), open)

  // Ferme le sous-menu quand le menu parent se ferme (transition uniquement :
  // en desktop parentOpen reste à false et le sous-menu doit pouvoir s'ouvrir)
  const [prevParentOpen, setPrevParentOpen] = useState(parentOpen)
  if (parentOpen !== prevParentOpen) {
    setPrevParentOpen(parentOpen)
    if (!parentOpen) setOpen(false)
  }

  const toggleMenu = () => {
    setOpen(!open)
  }

  return (
    <>
      <button type='button' id={id} className={link.link} onAuxClick={toggleMenu} onClick={toggleMenu} aria-expanded={open}>
        {label}
        <Icon icon={open ? "angle-up" : "angle-down"}/>
      </button>
      <div ref={ref} className={styles.wrapper} hidden={!open} aria-labelledby={id} id={`${id}-panel`}>
        <button type='button' className={styles.back} onAuxClick={toggleMenu} onClick={toggleMenu}>
          <Icon icon='angle-left'/>
          {label}
        </button>
        <ul className={styles.list}>
          {child.map(({url, label}, i) => (
            <li key={i}>
              <MenuLink url={url} label={label}/>
            </li>
          ))}
        </ul>
      </div>
    </>
  )
};
